import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, Instagram } from 'lucide-react';
import { services } from '../data/services';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-white/5" data-id="element-74">
      {/* Brand Banner */}
      <div className="max-w-7xl mx-auto px-6 pt-16" data-id="element-75">
        <a href="#contact" className="block relative rounded-3xl overflow-hidden border border-white/10 group" aria-label="Get in touch with Clydeside Gas Safe Heating" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/ddB6m9d5FqxG7S1TvHGUCT/ChatGPT_Image_Jun_4,_2026,_11_40_06_PM.png" alt="Clydeside Gas Safe Heating van — Local, Reliable, Professional" className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-77" />
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10" data-id="element-78">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-79">
          {/* Brand */}
          <div className="space-y-6" data-id="element-80">
            <Link to="/" className="flex items-center gap-3" data-id="element-81">
              <div className="w-10 h-10 rounded-xl bg-gradient-primary p-[1px]" data-id="element-82">
                <div className="w-full h-full bg-[#0a0a0a] rounded-xl flex items-center justify-center" data-id="element-83">
                  <Flame className="w-5 h-5 text-[#FF9500]" data-id="element-84" />
                </div>
              </div>
              <div className="flex flex-col" data-id="element-85">
                <span className="text-white font-bold text-lg leading-tight tracking-wide" data-id="element-86">
                  CLYDESIDE
                </span>
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-87">
                  Gas Safe Heating
                </span>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-88">
              Trusted, local Gas Safe registered engineers providing reliable
              heating solutions across Glasgow and Clydeside.
            </p>
            <div className="flex gap-4" data-id="element-89">
              <a href="https://www.instagram.com/clydesidegassafeheating" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-gradient-primary hover:text-black transition-all" data-id="element-90">
                <Instagram className="w-5 h-5" data-id="element-91" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-92">
            <h4 className="text-white font-bold mb-6" data-id="element-93">Our Services</h4>
            <ul className="space-y-3" data-id="element-94">
              {services.slice(0, 6).map(s => <li key={s.slug} data-id="element-95">
                  <Link to={`/services/${s.slug}`} className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-96">
                    {s.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-97">
            <h4 className="text-white font-bold mb-6" data-id="element-98">Quick Links</h4>
            <ul className="space-y-3" data-id="element-99">
              <li data-id="element-100">
                <Link to="/" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-101">
                  Home
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/#about" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-103">
                  About Us
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/#services" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-105">
                  Services
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/#contact" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-107">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-108">
            <h4 className="text-white font-bold mb-6" data-id="element-109">Contact Us</h4>
            <ul className="space-y-3" data-id="element-110">
              <li className="text-gray-400 text-sm" data-id="element-111">Glasgow, Scotland, UK</li>
              <li data-id="element-112">
                <a href="tel:07845242803" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-113">
                  07845 242803
                </a>
              </li>
              <li data-id="element-114">
                <a href="mailto:Clydesidegasandheating@gmail.com" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm break-all" data-id="element-115">
                  Clydesidegasandheating@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-116">
          <p className="text-gray-500 text-sm" data-id="element-117">
            &copy; {new Date().getFullYear()} Clydeside Gas Safe Heating. All
            rights reserved.
          </p>
          <div className="bg-white/5 border border-white/10 px-4 py-2 rounded-full" data-id="element-118">
            <span className="text-xs font-bold text-gray-400" data-id="element-119">
              GAS SAFE REGISTER NO.{' '}
              <span className="text-[#FFD600]" data-id="element-120">972580</span>
            </span>
          </div>
        </div>
      </div>
    </footer>;
}